// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { TrackGetString, ViewTrackMenuItemGetString, TrackVerticalItemContentGetString, TrackThumbnailGetString, TrackStationIconButtonGetString, TrackSongSearchResultHorizontalItemGetString, TrackShuffleWithSectionGetString, TrackShortTitleLabelGetString, TrackShareIconButtonGetString, TrackReportIconButtonGetString, TrackRelatedPlaylistsPageGetString, TrackRelatedArtistsPageGetString, TrackPlaybackPressableWrapperGetString, TrackPlayableImageGetString, TrackPlayPauseIconButtonGetString, TrackListItemOverflowMenuGetString, TrackListItemGetString, TrackLikeIconButtonGetString, TrackHorizontalItemOverflowMenuGetString, TrackHorizontalItemGetString, TrackEntityLabelGetString, TrackDetailPageSEOHeaderGetString, TrackDetailPageGetString, TrackBadgesGetString, TrackAddToQueueIconButtonGetString, ToggleDislikeTrackMenuItemGetString, ShareTrackMenuItemGetString, ReportTrackMenuItemGetString, RemoveTrackFromPlaylistMenuItemGetString, RelatedTracksPageGetString, QueueNextTrackMenuItemGetString, PlayTrackAsStationMenuItemGetString, EntityEdgeTrackVerticalItemContentGetString, DownloadTrackMenuItemGetString, AddTrackToEndOfQueueMenuItemGetString } from './types.generated'

const trackLocales = ['en-US'] as const

export const getString: TrackGetString = i18nBundle('track', trackLocales).getString
export const getStringTrack: TrackGetString = getString

const viewTrackMenuItemLocales = ['en-US'] as const

export const getStringViewTrackMenuItem: ViewTrackMenuItemGetString = i18nBundle('ViewTrackMenuItem', viewTrackMenuItemLocales).getString

const trackVerticalItemContentLocales = ['en-US'] as const

export const getStringTrackVerticalItemContent: TrackVerticalItemContentGetString = i18nBundle('TrackVerticalItemContent', trackVerticalItemContentLocales).getString

const trackThumbnailLocales = ['en-US'] as const

export const getStringTrackThumbnail: TrackThumbnailGetString = i18nBundle('TrackThumbnail', trackThumbnailLocales).getString

const trackStationIconButtonLocales = ['en-US'] as const

export const getStringTrackStationIconButton: TrackStationIconButtonGetString = i18nBundle('TrackStationIconButton', trackStationIconButtonLocales).getString

const trackSongSearchResultHorizontalItemLocales = ['en-US'] as const

export const getStringTrackSongSearchResultHorizontalItem: TrackSongSearchResultHorizontalItemGetString = i18nBundle('TrackSongSearchResultHorizontalItem', trackSongSearchResultHorizontalItemLocales).getString

const trackShuffleWithSectionLocales = ['en-US'] as const

export const getStringTrackShuffleWithSection: TrackShuffleWithSectionGetString = i18nBundle('TrackShuffleWithSection', trackShuffleWithSectionLocales).getString

const trackShortTitleLabelLocales = ['en-US'] as const

export const getStringTrackShortTitleLabel: TrackShortTitleLabelGetString = i18nBundle('TrackShortTitleLabel', trackShortTitleLabelLocales).getString

const trackShareIconButtonLocales = ['en-US'] as const

export const getStringTrackShareIconButton: TrackShareIconButtonGetString = i18nBundle('TrackShareIconButton', trackShareIconButtonLocales).getString

const trackReportIconButtonLocales = ['en-US'] as const

export const getStringTrackReportIconButton: TrackReportIconButtonGetString = i18nBundle('TrackReportIconButton', trackReportIconButtonLocales).getString

const trackRelatedPlaylistsPageLocales = ['en-US'] as const

export const getStringTrackRelatedPlaylistsPage: TrackRelatedPlaylistsPageGetString = i18nBundle('TrackRelatedPlaylistsPage', trackRelatedPlaylistsPageLocales).getString

const trackRelatedArtistsPageLocales = ['en-US'] as const

export const getStringTrackRelatedArtistsPage: TrackRelatedArtistsPageGetString = i18nBundle('TrackRelatedArtistsPage', trackRelatedArtistsPageLocales).getString

const trackPlaybackPressableWrapperLocales = ['en-US'] as const

export const getStringTrackPlaybackPressableWrapper: TrackPlaybackPressableWrapperGetString = i18nBundle('TrackPlaybackPressableWrapper', trackPlaybackPressableWrapperLocales).getString

const trackPlayableImageLocales = ['en-US'] as const

export const getStringTrackPlayableImage: TrackPlayableImageGetString = i18nBundle('TrackPlayableImage', trackPlayableImageLocales).getString

const trackPlayPauseIconButtonLocales = ['en-US'] as const

export const getStringTrackPlayPauseIconButton: TrackPlayPauseIconButtonGetString = i18nBundle('TrackPlayPauseIconButton', trackPlayPauseIconButtonLocales).getString

const trackListItemOverflowMenuLocales = ['en-US'] as const

export const getStringTrackListItemOverflowMenu: TrackListItemOverflowMenuGetString = i18nBundle('TrackListItemOverflowMenu', trackListItemOverflowMenuLocales).getString

const trackListItemLocales = ['en-US'] as const

export const getStringTrackListItem: TrackListItemGetString = i18nBundle('TrackListItem', trackListItemLocales).getString

const trackLikeIconButtonLocales = ['en-US'] as const

export const getStringTrackLikeIconButton: TrackLikeIconButtonGetString = i18nBundle('TrackLikeIconButton', trackLikeIconButtonLocales).getString

const trackHorizontalItemOverflowMenuLocales = ['en-US'] as const

export const getStringTrackHorizontalItemOverflowMenu: TrackHorizontalItemOverflowMenuGetString = i18nBundle('TrackHorizontalItemOverflowMenu', trackHorizontalItemOverflowMenuLocales).getString

const trackHorizontalItemLocales = ['en-US'] as const

export const getStringTrackHorizontalItem: TrackHorizontalItemGetString = i18nBundle('TrackHorizontalItem', trackHorizontalItemLocales).getString

const trackEntityLabelLocales = ['en-US'] as const

export const getStringTrackEntityLabel: TrackEntityLabelGetString = i18nBundle('TrackEntityLabel', trackEntityLabelLocales).getString

const trackDetailPageSEOHeaderLocales = ['en-US'] as const

export const getStringTrackDetailPageSEOHeader: TrackDetailPageSEOHeaderGetString = i18nBundle('TrackDetailPageSEOHeader', trackDetailPageSEOHeaderLocales).getString

const trackDetailPageLocales = ['en-US'] as const

export const getStringTrackDetailPage: TrackDetailPageGetString = i18nBundle('TrackDetailPage', trackDetailPageLocales).getString

const trackBadgesLocales = ['en-US'] as const

export const getStringTrackBadges: TrackBadgesGetString = i18nBundle('TrackBadges', trackBadgesLocales).getString

const trackAddToQueueIconButtonLocales = ['en-US'] as const

export const getStringTrackAddToQueueIconButton: TrackAddToQueueIconButtonGetString = i18nBundle('TrackAddToQueueIconButton', trackAddToQueueIconButtonLocales).getString

const toggleDislikeTrackMenuItemLocales = ['en-US'] as const

export const getStringToggleDislikeTrackMenuItem: ToggleDislikeTrackMenuItemGetString = i18nBundle('ToggleDislikeTrackMenuItem', toggleDislikeTrackMenuItemLocales).getString

const shareTrackMenuItemLocales = ['en-US'] as const

export const getStringShareTrackMenuItem: ShareTrackMenuItemGetString = i18nBundle('ShareTrackMenuItem', shareTrackMenuItemLocales).getString

const reportTrackMenuItemLocales = ['en-US'] as const

export const getStringReportTrackMenuItem: ReportTrackMenuItemGetString = i18nBundle('ReportTrackMenuItem', reportTrackMenuItemLocales).getString

const removeTrackFromPlaylistMenuItemLocales = ['en-US'] as const

export const getStringRemoveTrackFromPlaylistMenuItem: RemoveTrackFromPlaylistMenuItemGetString = i18nBundle('RemoveTrackFromPlaylistMenuItem', removeTrackFromPlaylistMenuItemLocales).getString

const relatedTracksPageLocales = ['en-US'] as const

export const getStringRelatedTracksPage: RelatedTracksPageGetString = i18nBundle('RelatedTracksPage', relatedTracksPageLocales).getString

const queueNextTrackMenuItemLocales = ['en-US'] as const

export const getStringQueueNextTrackMenuItem: QueueNextTrackMenuItemGetString = i18nBundle('QueueNextTrackMenuItem', queueNextTrackMenuItemLocales).getString

const playTrackAsStationMenuItemLocales = ['en-US'] as const

export const getStringPlayTrackAsStationMenuItem: PlayTrackAsStationMenuItemGetString = i18nBundle('PlayTrackAsStationMenuItem', playTrackAsStationMenuItemLocales).getString

const entityEdgeTrackVerticalItemContentLocales = ['en-US'] as const

export const getStringEntityEdgeTrackVerticalItemContent: EntityEdgeTrackVerticalItemContentGetString = i18nBundle('EntityEdgeTrackVerticalItemContent', entityEdgeTrackVerticalItemContentLocales).getString

const downloadTrackMenuItemLocales = ['en-US'] as const

export const getStringDownloadTrackMenuItem: DownloadTrackMenuItemGetString = i18nBundle('DownloadTrackMenuItem', downloadTrackMenuItemLocales).getString

const addTrackToEndOfQueueMenuItemLocales = ['en-US'] as const

export const getStringAddTrackToEndOfQueueMenuItem: AddTrackToEndOfQueueMenuItemGetString = i18nBundle('AddTrackToEndOfQueueMenuItem', addTrackToEndOfQueueMenuItemLocales).getString

